import React, { useState, useEffect } from "react";
import Logo from "../images/shine_header_logo.png";
import Jigar_Thanki from "../images/jigar_thanki.jpg";
import { Link, useParams, useLocation } from "react-router-dom";
import { format } from "date-fns";
import axios from "axios";
import config from "../config";

const helperImg = [
  { images: Jigar_Thanki, name: "Jack" },
  { images: Jigar_Thanki, name: "Jack" },
  { images: Jigar_Thanki, name: "Jack" },
  { images: Jigar_Thanki, name: "Jack" },
  { images: Jigar_Thanki, name: "Jack" },
  { images: Jigar_Thanki, name: "Jack" },
  { images: Jigar_Thanki, name: "Jack" },
];

const Clientthankyou = () => {
  const [currentImage, setCurrentImage] = useState(helperImg[1]);
  const [userDetails, setUserDetails] = useState();
  const params = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isSkipped = searchParams.get("skip") === "true"; // check if skip flag is passed

  const getUserData = async () => {
    const result = await axios(
      `${config.baseUrl}/hiredeveloper/email/${params.id}`
    );
    setUserDetails(result?.data?.data);
  };

  useEffect(() => {
    document.body.className = "";
    document.title =
      "Your Gateway To Hire Top 1% Of Highly Skilled Remote Team";
    document.querySelector("meta[name='description']").content =
      "Hire the Top 1% of Highly Skilled Remote Team with Vetted Over 20+ Technical Skills. So You Can Start Focusing More Upon the Building. Contact Us Today!";

    if (params.id && !isSkipped) getUserData(); // fetch email only if not skipped

    const dayOfWeek = format(new Date(), "EEEEEE");
    const dayToIndex = {
      Mo: 0,
      Tu: 1,
      We: 2,
      Th: 3,
      Fr: 4,
      Sa: 5,
      Su: 6,
    };

    setCurrentImage(helperImg[dayToIndex[dayOfWeek] || 0]);
  }, [params, isSkipped]);

  return (
    <>
      <section className="clientThankSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="logo">
                <img src={Logo} alt="Hire Mobile App Developers" />
              </div>
            </div>
            <div className="col-md-12">
              <div className="heading">
                <h3>Thank you for your interest!</h3>
                <p>
                  Thank you for providing us with the opportunity to serve you.
                  We assure you for best services. We are sure that our
                  technical partnership will have fruitful result with mutual
                  benefits.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div className="details">
                <img
                  src={currentImage?.images}
                  alt="Hire Dedicated Developers"
                />
                <h5>
                  <span>{currentImage?.name}</span> will contact you soon!
                </h5>
                {/* Only show email line if not skipped */}
                {!isSkipped && userDetails && (
                  <p>
                    Your meeting invitation link has been sent to:{" "}
                    <strong>{userDetails}</strong>
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <Link to="/" className="btn">
                <span>Back to home</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Clientthankyou;
